export function displayMessageShorten(message: string, maxLength: number): string {
  return message.length > maxLength ? `${message.slice(0, maxLength)}...` : message;
}
